var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.25C0 3.2207 2.44922 0.75 5.5 0.75C8.5293 0.75 11 3.2207 11 6.25C11 9.30078 8.5293 11.75 5.5 11.75C2.44922 11.75 0 9.30078 0 6.25ZM7.9707 5.30469C8.20703 5.06836 8.20703 4.70312 7.9707 4.4668C7.73438 4.23047 7.36914 4.23047 7.13281 4.4668L4.8125 6.78711L3.8457 5.8418C3.60938 5.60547 3.24414 5.60547 3.00781 5.8418C2.77148 6.07812 2.77148 6.44336 3.00781 6.67969L4.38281 8.05469C4.61914 8.29102 4.98438 8.29102 5.2207 8.05469L7.9707 5.30469Z",
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusSuccess);
export default __webpack_public_path__ + "static/media/status-success.fcc4a9df8c8e4e075514c164d0ed767d.svg";
export { ForwardRef as ReactComponent };